import React, { useContext } from 'react'
import FavItems from '../Components/FavItems/FavItems'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Header/Header'
import {cntxtCmngFrmFldOprtn} from '../Helpers/Helpers'
import ProfileDropDown from '../Components/ProfileDropDown/ProfileDropDown'
import LoginOptions from '../Components/LoginOptions/LoginOptions'
import Options from '../Components/Options/Options'
import { Contextuser } from '../App';
import HumburgerMenu from '../Components/HumburgerMenu/HumburgerMenu'

function Favourites() {
  const user = useContext(Contextuser)
  const LogedUserName=user.name
  const {ShowDropDown, setShowDropDown,DontShowLogin, setLoginStatus,favLogin, setfavLogin}= useContext(cntxtCmngFrmFldOprtn)

  return (
    <div className='Fav_Container'>
      {ShowDropDown && <ProfileDropDown setShowDropDown={setShowDropDown} />}
      {DontShowLogin ? "" : <LoginOptions setLoginStatus={setLoginStatus} favLogin={favLogin} setfavLogin={setfavLogin} />}
      <Header setShowDropDown={setShowDropDown} setLoginStatus={setLoginStatus}/> 
      <Options/>
      <HumburgerMenu LogedUserName={LogedUserName}/>
      <FavItems/>
      <Footer/>
    </div>
  )
}

export default Favourites
